export default [
  // {
  //   path: 'settlement/batch',
  //   name: 'Settlement Batch Management',
  //   component: () => import('@/views/settlement/settlement-batch/index.vue'),
  //   meta: {
  //     icon: 'el-icon-s-finance',
  //     resourceCode: 'settlement:batch',
  //     name: 'message.settlement.batch',
  //   },
  // },
  // {
  //   path: 'settlement/details',
  //   name: 'Settlement Detail Management',
  //   component: () => import('@/views/settlement/settlement-details/index.vue'),
  //   meta: {
  //     resourceCode: 'settlement:details',
  //     name: 'message.settlement.details',
  //   },
  // },
  {
    path: 'settlement/balance',
    name: 'Settlement Balance',
    component: () => import('@/views/settlement/balance/index.vue'),
    // meta: {
    //   resourceCode: 'settlement:balance',
    // },
  },
  // {
  //   path: 'settlement/declaration',
  //   name: 'Settlement Detail Management',
  //   component: () => import('@/views/settlement/restore-detailed-declaration/index.vue'),
  //   meta: {
  //     resourceCode: 'settlement:declaration',
  //   },
  // },
  {
    path: 'settlement/payee-manage',
    name: 'Settlement Payee Manage',
    component: () => import('@/views/settlement/payee-manage/index.vue'),
    meta: {
      resourceCode: 'settlement:payee',
    },
  },
  {
    path: 'settlement/payee-manage/add',
    name: 'Settlement Payee Add',
    component: () => import('@/views/settlement/payee-manage/add/index.vue'),
  },
  {
    path: 'settlement/payee-manage/edit',
    name: 'Settlement Payee Edit',
    component: () => import('@/views/settlement/payee-manage/add/index.vue'),
  },
  {
    path: 'settlement/payee-manage/view',
    name: 'Settlement Payee View',
    component: () => import('@/views/settlement/payee-manage/view/index.vue'),
  },
  {
    path: 'settlement/disbursement',
    name: 'Disbursement Query',
    component: () => import('@/views/settlement/disbursement/index.vue'),
    meta: {
      resourceCode: 'settlement:disbursement',
    },
  },
];
